import { createAction } from '@reduxjs/toolkit'

import { IPostPurchaseBrandConnectAnalytics, PostPurchaseBrandConnectActionTypes } from './types'

export const fetchPostPurchaseBrandConnectAnalytics = createAction<number>(
  PostPurchaseBrandConnectActionTypes.FETCH_REQUEST,
)

export const fetchPostPurchaseBrandConnectAnalyticsSuccess = createAction(
  PostPurchaseBrandConnectActionTypes.FETCH_SUCCESS,
  (submissionId: number, postPurchaseAnalytics: IPostPurchaseBrandConnectAnalytics[]) => ({
    payload: { submissionId, postPurchaseAnalytics },
  }),
)

export const fetchPostPurchaseBrandConnectAnalyticsError = createAction<unknown>(
  PostPurchaseBrandConnectActionTypes.FETCH_ERROR,
)
